import { z } from 'zod';
import { inferApiResultSchema } from './infer-api';

export const AccountSettingSchema = z.object({
  accountId: z.string().max(50),
  name: z.string().max(300),
  portalSlug: z.string().min(8).max(300),
  loginLogoKey: z.string().nullish(),
  primaryColor: z.string().regex(/^#[0-9A-Fa-f]{6}$/, 'Invalid hex color format'),
  secondaryColor: z.string().regex(/^#[0-9A-Fa-f]{6}$/, 'Invalid hex color format'),
  faviconKey: z.string().nullish(),
  createdAt: z.date(),
  updatedAt: z.date(),
  loginLogoUrl: z.string().max(2083).nullish(),
  faviconUrl: z.string().max(2083).nullish(),
  autoCreateCustomer: z.boolean(),
  includeInLandingPage: z.boolean().nullish(),
  priorityFrameworks: z.string().nullish(),
  defaultDemandPriorityFrameworkId: z.number().int().positive().nullish(),
});

// GET /api/account-settings response schema
export type AccountSettingsDto = z.infer<typeof AccountSettingSchema>;

export const GetAccountSettingsResponseSchema = inferApiResultSchema(AccountSettingSchema);

export type GetAccountSettingsResponseDto = z.infer<typeof GetAccountSettingsResponseSchema>;

// PUT /api/account-settings/:id response schema
export const UpdateAccountSettingsSchema = AccountSettingSchema.omit({
  accountId: true,
  createdAt: true,
  updatedAt: true,
  loginLogoUrl: true,
  faviconUrl: true,
}).partial();

export const UpdateAccountSettingsResponseSchema = inferApiResultSchema(AccountSettingSchema);
export type UpdateAccountSettingsDto = z.infer<typeof UpdateAccountSettingsSchema>;
export type UpdateAccountSettingsResponseDto = z.infer<typeof UpdateAccountSettingsResponseSchema>;
